/*
  industrialkonzept Editorial article (sections/ik-article.liquid), 2026-09-23.
  Progress line, "Up next" note, pictures large, share as a story picture, objects in the margin.
*/
(() => {
  const root = document.querySelector('[data-ika]');
  const body = document.querySelector('[data-ika-body]');
  if (!root || !body) return;
  const str = (k, d) => ((document.querySelector('[data-ika-str-' + k + ']') || {}).textContent || d).trim();
  /* The article's own text: everything in the body except the key facts box (the excerpt, ik-article.liquid),
     so pictures, products and designers are only ever looked for in the story itself */
  const parts = [...body.children].filter((el) => !el.classList.contains('ika-facts'));

  /* Paragraphs that only hold pictures become figures (a little wider than the text) */
  parts.forEach((el) => {
    if (!el.matches('p, div') || !el.querySelector('img') || el.textContent.trim()) return;
    el.classList.add('ika-figure');
  });

  /* Progress line and "Up next" */
  const bar = document.querySelector('[data-ika-progress]');
  const pill = document.querySelector('[data-ika-pill]');
  const next = document.querySelector('[data-ika-next]');
  if (pill) pill.hidden = false;
  let ticking = false;
  const onScroll = () => {
    ticking = false;
    const r = body.getBoundingClientRect();
    const total = r.height - innerHeight * 0.6;
    const done = Math.min(1, Math.max(0, (innerHeight * 0.4 - r.top) / Math.max(total, 1)));
    if (bar) bar.style.transform = 'scaleX(' + done.toFixed(4) + ')';
    if (pill) {
      const nextInView = next && next.getBoundingClientRect().top < innerHeight;
      pill.classList.toggle('is-on', done > 0.55 && !nextInView);
    }
  };
  addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(onScroll);
    }
  }, { passive: true });
  addEventListener('resize', onScroll);
  onScroll();

  /* Pictures large on click */
  const box = document.querySelector('[data-ika-zoombox]');
  const big = document.querySelector('[data-ika-zoomimg]');
  const close = () => {
    box.hidden = true;
    big.removeAttribute('src');
    document.documentElement.style.overflow = '';
  };
  if (box && big) {
    document.querySelectorAll('.ika-cover img, [data-ika-body] img').forEach((img) => {
      if (img.closest('a')) return;
      img.addEventListener('click', () => {
        const src = img.currentSrc || img.src;
        big.src = src.replace(/([?&])width=\d+/, '$1width=2800');
        big.alt = img.alt || '';
        box.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      });
    });
    box.addEventListener('click', close);
    addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !box.hidden) close();
    });
  }

  /* Share as a story: a 9:16 picture (1080 × 1920, the Instagram story size) drawn here in the browser from
     the cover, with topic, reading time, title, "Read the story on …" and the logo in white. Nothing is stored
     anywhere and every article gets its picture by itself. The picture is made ahead, when the button comes
     near, so a tap can open the share sheet at once (phones only allow that straight after the tap).
     Phones: share sheet with picture and link (Instagram, WhatsApp …), the link is also copied for the
     story's link sticker. Computers: a quiet window with the picture, "Save picture" and "Copy link" (window.ikStoryPreview in ik-lab.js). */
  const drawStory = async ({ img, logo, title, topic, time, cta }) => {
    const W = 1080, H = 1920, M = 84;
    const load = (src) => new Promise((ok, no) => {
      const i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = () => ok(i);
      i.onerror = no;
      i.src = src;
    });
    const [pic, mark] = await Promise.all([load(img), logo ? load(logo).catch(() => null) : null]);
    const c = document.createElement('canvas');
    c.width = W;
    c.height = H;
    const x = c.getContext('2d');
    const spacing = (v) => { if ('letterSpacing' in x) x.letterSpacing = v; };
    const font = (px) => `400 ${px}px Helvetica, "Helvetica Neue", Arial, sans-serif`;
    x.fillStyle = '#111';
    x.fillRect(0, 0, W, H);
    // the cover fills the frame, cut to fit from the middle
    const k = Math.max(W / pic.width, H / pic.height);
    x.drawImage(pic, (W - pic.width * k) / 2, (H - pic.height * k) / 2, pic.width * k, pic.height * k);
    // shade: a little at the top for the labels, more at the bottom for the title
    let g = x.createLinearGradient(0, 0, 0, 520);
    g.addColorStop(0, 'rgba(0,0,0,0.45)');
    g.addColorStop(1, 'rgba(0,0,0,0)');
    x.fillStyle = g;
    x.fillRect(0, 0, W, 520);
    g = x.createLinearGradient(0, H * 0.3, 0, H);
    g.addColorStop(0, 'rgba(0,0,0,0)');
    g.addColorStop(0.35, 'rgba(0,0,0,0.5)');
    g.addColorStop(1, 'rgba(0,0,0,0.9)');
    x.fillStyle = g;
    x.fillRect(0, H * 0.3, W, H * 0.7);

    // labels at the top, below the space Instagram uses for its own bar
    x.fillStyle = '#fff';
    x.font = font(30);
    spacing('3px');
    x.textAlign = 'left';
    x.fillText(String(topic || '').toUpperCase(), M, 300);
    x.textAlign = 'right';
    x.fillText(String(time || '').toUpperCase(), W - M, 300);
    spacing('0px');

    // the title as big as fits in at most 5 lines. Title, call to read and the free room below them for
    // Instagram's link sticker sit together a little above the middle, so the picture looks balanced
    // once the sticker is on it
    const wrap = (px) => {
      x.font = font(px);
      const lines = [];
      let line = '';
      for (const w of String(title).split(/\s+/)) {
        const t = line ? line + ' ' + w : w;
        if (x.measureText(t).width > W - 2 * M && line) {
          lines.push(line);
          line = w;
        } else line = t;
      }
      if (line) lines.push(line);
      return lines;
    };
    let px = 96;
    let lines = wrap(px);
    while ((lines.length > 5 || lines.some((l) => x.measureText(l).width > W - 2 * M)) && px > 52) lines = wrap((px -= 4));
    const lh = Math.round(px * 1.04);
    const titleH = (lines.length - 1) * lh + px;
    const STICKER = 300;
    const bottom = Math.round(Math.max(380, H * 0.47 - (titleH + 80 + STICKER) / 2) + titleH);
    // a soft dark band behind title and call to read, so white text stays readable on bright covers
    const bandTop = bottom - titleH - 260, bandEnd = bottom + 360;
    g = x.createLinearGradient(0, bandTop, 0, bandEnd);
    g.addColorStop(0, 'rgba(0,0,0,0)');
    g.addColorStop(0.35, 'rgba(0,0,0,0.38)');
    g.addColorStop(0.75, 'rgba(0,0,0,0.38)');
    g.addColorStop(1, 'rgba(0,0,0,0)');
    x.fillStyle = g;
    x.fillRect(0, bandTop, W, bandEnd - bandTop);
    x.fillStyle = '#fff';
    x.textAlign = 'left';
    x.font = font(px);
    spacing(`${-px * 0.02}px`);
    lines.forEach((l, i) => x.fillText(l, M - 4, bottom - (lines.length - 1 - i) * lh));
    spacing('0px');

    // call to read, free room for the link sticker, then the logo in white, centred, above Instagram's reply bar
    x.font = font(34);
    x.globalAlpha = 0.85;
    x.fillText(cta, M, bottom + 80);
    x.globalAlpha = 1;
    if (mark) {
      const lw = 300, lhh = (mark.height / mark.width) * lw;
      const o = document.createElement('canvas');
      o.width = lw;
      o.height = lhh;
      const ox = o.getContext('2d');
      ox.drawImage(mark, 0, 0, lw, lhh);
      ox.globalCompositeOperation = 'source-in';
      ox.fillStyle = '#fff';
      ox.fillRect(0, 0, lw, lhh);
      x.drawImage(o, (W - lw) / 2, H - 260 - lhh / 2);
    }
    return new Promise((ok) => c.toBlob(ok, 'image/jpeg', 0.92));
  };

  const share = document.querySelector('[data-ika-share]');
  if (share) {
    const d = share.dataset;
    const url = location.href.split('#')[0];
    const label = share.textContent.trim();
    // the logo from the theme settings (the same file as in the header), independent of language and device
    const logo = d.logo ? (d.logo.startsWith('//') ? 'https:' + d.logo : d.logo) + '&ika=story' : '';
    let story = null; // the finished picture as a file, or a promise of it
    let failed = false; // the cover could not be drawn: then the link alone is shared
    const prepare = () => {
      if (!story && !failed && d.img) {
        story = drawStory({ img: d.img + (d.img.includes('?') ? '&' : '?') + 'ika=story', logo, title: d.title, topic: d.topic, time: d.time, cta: d.cta })
          .then((blob) => (story = blob ? new File([blob], d.file || 'story.jpg', { type: 'image/jpeg' }) : null))
          .catch(() => (story = null))
          .then((f) => (failed = !f, f));
      }
      return story;
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => {
        if (es.some((e) => e.isIntersecting)) {
          io.disconnect();
          prepare();
        }
      }, { rootMargin: '2000px 0px' });
      io.observe(share);
    }
    const say = (text) => {
      share.textContent = text;
      setTimeout(() => (share.textContent = label), 2500);
    };
    share.addEventListener('click', async () => {
      // the link is copied at once only where there is no window to copy it from (phones, or no picture)
      const phoneTap = navigator.share && matchMedia('(pointer: coarse)').matches;
      const copy = navigator.clipboard && (phoneTap || !window.ikStoryPreview)
        ? navigator.clipboard.writeText(url).then(() => true, () => false)
        : Promise.resolve(false);
      let file = prepare();
      const phone = navigator.share && matchMedia('(pointer: coarse)').matches;
      if (phone) {
        // the sheet only opens straight after a tap: if the picture is not ready yet, wait for it and ask for
        // a second tap, so the picture always comes along
        if (file && !(file instanceof File)) {
          share.textContent = str('preparing', 'Preparing picture …');
          await file;
          share.textContent = str('tapshare', 'Tap to share');
          return;
        }
        const withPic = file instanceof File && navigator.canShare && navigator.canShare({ files: [file] });
        try {
          await navigator.share(withPic ? { files: [file], title: d.title, text: d.title + ' ' + url } : { title: d.title, url });
        } catch (e) {}
        share.textContent = label;
        return;
      }
      if (file && !(file instanceof File)) {
        share.style.opacity = '0.5';
        file = await file;
        share.style.opacity = '';
      }
      if (file instanceof File && window.ikStoryPreview) {
        // a quiet window with the picture, "Save picture" and "Copy link" (ik-lab.js), nothing downloaded at once
        window.ikStoryPreview(file, url, d.title);
      } else if (file instanceof File) {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(file);
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(a.href), 5000);
        say(d.done);
      } else {
        // no picture (an article without a cover, or it could not be drawn): copy the link instead, as the
        // product pages do, so the click never does nothing
        const ok = (await copy) || (navigator.clipboard ? await navigator.clipboard.writeText(url).then(() => true, () => false) : false);
        if (ok) say(d.copied);
      }
    });
  }

  /* Objects in the margin, found in the text itself (no upkeep):
     1. products linked in the text, next to their paragraph;
     2. products of a brand named in the article whose name stands in the text, always with its next word
        ("Triangolo Chair", "Ava Lamps", "Easy Chair"), so ordinary words like "From" or "Door" never match;
     3. designers we carry named in the text ("Kristina Dam"), with a link to their objects.
     At most 4 notes, one per paragraph, products first. Measured on 30 articles: 9 with notes, 0 wrong. */
  const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // prices look exactly like the theme's (window.ikMoney, layout/theme.liquid)
  const money = { format: (units) => window.ikMoney(Math.round(units * 100)) };
  const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const img = (u, w) => (u ? (u.startsWith('//') ? 'https:' + u : u) + (u.includes('?') ? '&' : '?') + 'width=' + w : '');
  const json = (u) => fetch(u, { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null);
  const get = (h) => json(base + 'products/' + h + '.js');
  const MAX = 4;

  const blocks = parts.filter((el) => !el.classList.contains('ika-figure') && el.textContent.trim().length > 60);
  const blockOf = (node) => {
    while (node && node.parentElement !== body) node = node.parentElement;
    return node;
  };
  const title = body.getAttribute('data-ika-title') || '';
  const atThird = () => blocks[Math.min(blocks.length - 1, Math.round(blocks.length * 0.3))];

  // 1. Linked products
  const linked = [];
  body.querySelectorAll('a[href*="/products/"]').forEach((a) => {
    const m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    const block = blockOf(a);
    if (m && parts.includes(block) && !linked.some((p) => p.h === m[1])) linked.push({ h: m[1], before: block, anchor: a });
  });
  // products chosen for the article (Products field, written first into the rail by ik-article-shop.liquid)
  // get their notes first, in that order; the other links follow in the order of the text
  const pickedTrack = document.querySelector('[data-ikn-articleshop-picked] [data-ikn-articleshop-track]');
  const picked = pickedTrack
    ? [...pickedTrack.querySelectorAll('a.ikh-card')].map((a) => (a.getAttribute('href') || '').split('?')[0].split('/').pop())
    : [];
  const rank = (h) => (picked.includes(h) ? picked.indexOf(h) : picked.length);
  linked.sort((p, q) => rank(p.h) - rank(q.h));

  // 2. Products named in the text
  const TYPES = new Set(('chair lamp table stool sofa vase pendant shelf shelve bowl mirror rug cushion tray box candle holder bench ' +
    'cabinet desk lounge light sconce armchair daybed bed ottoman pouf trolley cart rack hook plate cup mug jug carafe glass ' +
    'planter pot basket clock frame stand screen divider sideboard dresser wardrobe console chest bookcase bookshelf cover ' +
    'blanket throw pillow towel mat lantern diffuser speaker series collection system').split(' '));
  const stem = (w) => w.toLowerCase().replace(/(es|s)$/, '').replace(/ie$/, 'y');
  const isType = (w) => TYPES.has(stem(w)) || TYPES.has(w.toLowerCase());
  let vendors = [];
  try {
    vendors = JSON.parse((document.querySelector('[data-ika-vendors]') || {}).textContent || '[]');
  } catch (e) {}
  const vendorNames = new Set(vendors.map((v) => v[0].toLowerCase()));
  const wordRe = (w) => new RegExp('(^|[^\\p{L}\\p{N}])' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?![\\p{L}\\p{N}])', 'u');
  const fullText = title + ' \n ' + parts.map((el) => el.textContent).join(' \n ');

  const namedProducts = () => {
    const brands = vendors.filter(([name]) => {
      if (name.length < 3 || /industrial/i.test(name)) return false;
      const strict = name.length <= 4 || name === name.toUpperCase();
      return new RegExp(wordRe(name).source, strict ? 'u' : 'iu').test(fullText);
    }).slice(0, 4);
    if (!brands.length) return Promise.resolve([]);
    const pages = (handle) =>
      json(base + 'collections/' + handle + '/products.json?limit=250&page=1').then((a) => {
        const list = (a && a.products) || [];
        if (list.length < 250) return list;
        return json(base + 'collections/' + handle + '/products.json?limit=250&page=2').then((b) => list.concat((b && b.products) || []));
      });
    return Promise.all(brands.map(([name, handle]) => pages(handle).then((list) => ({ name, list })))).then((all) => {
      const found = {};
      all.forEach(({ name, list }) => {
        list.forEach((p) => {
          const words = (p.title.split(' - ')[0].replace(new RegExp('^' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s+', 'i'), '').match(/[\p{L}\p{N}'’.&-]+/gu)) || [];
          const key = words[0];
          if (!key || key.length < 3 || !/^\p{Lu}/u.test(key) || isType(key) || vendorNames.has(key.toLowerCase())) return;
          const inTitle = new Set(words.slice(1).map(stem));
          const re = new RegExp(wordRe(key).source + "(?:[’']s)? ([\\p{L}\\p{N}-]+)", 'gu');
          const sources = [{ text: title, block: null }].concat(blocks.map((b) => ({ text: b.textContent, block: b })));
          for (const src of sources) {
            let m;
            re.lastIndex = 0;
            while ((m = re.exec(src.text))) {
              const next = m[2];
              if (next === words[1] || (isType(next) && inTitle.has(stem(next)))) {
                const id = name + '|' + key + ' ' + stem(next);
                const f = (found[id] = found[id] || { before: src.block || atThird(), pos: src.block ? blocks.indexOf(src.block) : -1, next, list: [] });
                f.list.push(p);
                return;
              }
            }
          }
        });
      });
      return Object.values(found).map((f) => {
        // the matching kind first ("Folding Flat Chair" → the chair, not the table trestles), in stock first
        const pick = f.list.slice().sort((a, b) => {
          const s = (p) => (p.title.toLowerCase().includes(stem(f.next)) ? 2 : 0) + (p.variants.some((v) => v.available) ? 1 : 0);
          return s(b) - s(a);
        })[0];
        return { h: pick.handle, before: f.before };
      });
    });
  };

  // 3. Designers named in the text (same numbers as the A–Z page, remembered for a day)
  const designers = () => {
    const KEY = 'ikn-az-v1';
    try {
      const hit = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (hit && Date.now() - hit.t < 24 * 3600 * 1000) return Promise.resolve(hit.d);
    } catch (e) {}
    const url = (p) => base + 'collections/all?view=ikn-designer-data&page=' + p;
    return json(url(1)).then((first) => {
      if (!first) return {};
      const rest = [];
      for (let p = 2; p <= first.pages; p++) rest.push(json(url(p)));
      return Promise.all(rest).then((more) => {
        const d = {};
        [first, ...more].forEach((pg) => pg && Object.entries(pg.d).forEach(([k, v]) => (d[k] = (d[k] || 0) + v)));
        // only a complete list is remembered: the homepage counter and the A–Z page read it too
        if (more.some((pg) => !pg)) return d;
        try {
          localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d }));
        } catch (e) {}
        return d;
      });
    });
  };
  const namedDesigners = () =>
    designers().then((d) =>
      Object.keys(d)
        .filter((n) => n.includes(' ') && n.length >= 7)
        .map((n) => {
          const re = wordRe(n);
          const block = blocks.find((b) => re.test(b.textContent));
          return block ? { designer: n, count: d[n], before: block, pos: blocks.indexOf(block) } : null;
        })
        .filter(Boolean)
        .sort((a, b) => a.pos - b.pos)
    );

  const used = new Set();
  let shown = 0;
  // no note above the first real paragraph: the earliest spot is right after it, never next to the key facts
  const earliest = blocks[1];
  const notBefore = (el) => (earliest && (el === earliest || earliest.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING) ? el : earliest);
  // one note per paragraph; if the paragraph is taken, the next free one (at most two further)
  const take = (list, draw) =>
    list.forEach((item) => {
      if (shown >= MAX || !item.before) return;
      let spot = notBefore(item.before);
      let at = blocks.indexOf(spot);
      for (let i = 0; used.has(spot) && i < 2 && at > -1; i++) spot = blocks[++at];
      if (!spot || used.has(spot)) return;
      used.add(spot);
      shown++;
      // on wide screens the note sits at the mention itself (anchor), on phones before its paragraph (spot)
      draw(Object.assign({}, item, { before: spot, anchor: item.anchor || item.before }));
    });

  namedProducts()
    .then((named) => linked.concat(named.filter((x) => !linked.some((l) => l.h === x.h))))
    // only products that can be bought get a note, so a sold-out one never takes a paragraph
    .then((list) => Promise.all(list.map((x) => get(x.h).then((p) => (p && p.available ? Object.assign({}, x, { p }) : null)))))
    .then((found) => {
      // one entry per model: "Folding Flat Chair - Dark Brown Birch" and "… - Natural Birch" count once
      const models = new Set();
      const products = found.filter(Boolean).filter((x) => {
        const model = x.p.title.split(' - ')[0].trim().toLowerCase();
        return models.has(model) ? false : models.add(model);
      });
      take(products, productNote);
      fillRail(products.map((p) => p.h));
      return shown < MAX ? namedDesigners() : [];
    })
    .then((list) => take(list, designerNote))
    .then(placeNotes)
    .catch(() => {});

  function productNote({ p, before, anchor }) {
    const price = (p.price_varies ? str('from', 'from') + ' ' : '') + money.format(p.price_min / 100);
    const a = document.createElement('a');
    a.className = 'ika-note';
    a.href = base + 'products/' + p.handle;
    a.innerHTML =
      '<span class="ika-note__media">' + (p.featured_image ? '<img src="' + esc(img(p.featured_image, 480)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</span>' +
      '<span class="ika-note__text"><span class="ika-note__label">' + esc(str('note', 'In the story')) + '</span>' +
      '<span class="ika-note__vendor">' + esc(p.vendor) + '</span>' +
      '<span class="ika-note__title">' + esc(p.title) + '</span>' +
      '<span>' + esc(price) + '</span>' +
      '<span class="ika-note__view">' + esc(str('view', 'View')) + ' &rarr;</span></span>';
    a.ikaAnchor = anchor;
    body.insertBefore(a, before);
  }

  function designerNote({ designer, count, before, anchor }) {
    const a = document.createElement('a');
    a.className = 'ika-note ika-note--designer';
    a.href = base + 'collections/all?filter.p.m.custom.designer=' + encodeURIComponent(designer);
    a.innerHTML =
      '<span class="ika-note__text"><span class="ika-note__label">' + esc(str('designer', 'Designer')) + '</span>' +
      '<span class="ika-note__name">' + esc(designer) + '</span>' +
      '<span class="ika-note__vendor">' + count + ' ' + esc(count === 1 ? str('object', 'object') : str('objects', 'objects')) + '</span>' +
      '<span class="ika-note__view">' + esc(str('more', 'More by')) + ' ' + esc(designer) + ' &rarr;</span></span>';
    a.ikaAnchor = anchor;
    body.insertBefore(a, before);
  }

  /* Wide screens: each note level with the line that mentions it, in the right margin; if the right margin is
     taken there (another note, or a picture reaching into the margin), the left one; otherwise the nearest free
     spot. Phones keep the notes between the paragraphs. Recalculated whenever the text moves (pictures loading,
     fonts, window size). If anything fails, the notes simply stay in the right margin as before. */
  const wide = window.matchMedia('(min-width: 1280px)');
  let layoutQueued = false;
  function layoutNotes() {
    layoutQueued = false;
    const notes = [...body.querySelectorAll('.ika-note')];
    if (!notes.length) return;
    if (!wide.matches) {
      body.classList.remove('ika-notes-abs');
      body.style.minHeight = '';
      notes.forEach((n) => {
        n.classList.remove('is-left', 'is-right');
        n.style.top = '';
        n.style.left = '';
        n.style.width = '';
      });
      return;
    }
    try {
      body.classList.add('ika-notes-abs');
      body.style.minHeight = '';
      const b = body.getBoundingClientRect();
      const rel = (el) => {
        const r = el.getBoundingClientRect();
        return { top: r.top - b.top, bottom: r.bottom - b.top };
      };
      const GAP = 24;
      const UP = 160; // a note may start a little above its line, never further
      const MARGIN = 48; // space between the text and a note (3rem)
      const pad = parseFloat(getComputedStyle(body).paddingLeft) || 0;
      const textLeft = pad;
      const textRight = body.clientWidth - pad;
      // pictures reach a little into the margins: where the window has room, the notes sit just beyond them,
      // so a picture never pushes a note away from its line (on narrower windows the notes get a little
      // narrower, down to 150 px; below that they keep clear of the pictures instead)
      const figs = [...body.querySelectorAll('.ika-figure')].map((f) => f.getBoundingClientRect());
      const over = Math.max(0, ...figs.map((r) => r.right - b.left - textRight), ...figs.map((r) => textLeft - (r.left - b.left)));
      const page = document.documentElement.clientWidth;
      const room = Math.min(page - (b.left + textRight + over), b.left + textLeft - over) - 24 - 16;
      const beyond = room >= 150;
      const width = beyond ? Math.min(240, Math.floor(room)) : 240;
      notes.forEach((n) => (n.style.width = width + 'px'));
      const out = beyond ? Math.max(MARGIN, over + 24) : MARGIN;
      const x = { right: textRight + out, left: textLeft - out - width };
      const pictures = { right: [], left: [] };
      if (!beyond) {
        figs.forEach((r) => {
          const o = { top: r.top - b.top, bottom: r.bottom - b.top };
          if (r.right - b.left > x.right) pictures.right.push(o);
          if (r.left - b.left < x.left + width) pictures.left.push(o);
        });
      }
      const taken = { right: [], left: [] };
      const first = blocks[1] ? rel(blocks[1]).top : 0;
      const items = notes
        .map((n) => {
          const at = n.ikaAnchor && body.contains(n.ikaAnchor) ? n.ikaAnchor : n.nextElementSibling || n;
          return { n, want: Math.max(first, rel(at).top - 4) };
        })
        .sort((x, y) => x.want - y.want);
      let lowest = 0;
      items.forEach(({ n, want }) => {
        n.classList.add('is-right');
        n.classList.remove('is-left');
        const h = n.offsetHeight;
        const free = (side, top) => pictures[side].concat(taken[side]).every((o) => top + h + GAP <= o.top || top >= o.bottom + GAP);
        const best = (side) => {
          const tries = [want];
          pictures[side].concat(taken[side]).forEach((o) => tries.push(o.bottom + GAP, o.top - h - GAP));
          return tries
            .filter((t) => t >= Math.max(first, want - UP) && free(side, t))
            .sort((x, y) => Math.abs(x - want) - Math.abs(y - want))[0];
        };
        const r = best('right');
        const l = best('left');
        const left = r === undefined || (l !== undefined && Math.abs(l - want) + 8 < Math.abs(r - want));
        const top = Math.round((left ? l : r) ?? want);
        n.classList.toggle('is-left', left);
        n.classList.toggle('is-right', !left);
        n.style.top = top + 'px';
        n.style.left = Math.round(x[left ? 'left' : 'right']) + 'px';
        taken[left ? 'left' : 'right'].push({ top, bottom: top + h });
        lowest = Math.max(lowest, top + h);
      });
      // a note low down never runs into the end of the article
      if (lowest + GAP > body.offsetHeight) body.style.minHeight = Math.ceil(lowest + GAP) + 'px';
    } catch (e) {
      body.classList.remove('ika-notes-abs');
      body.style.minHeight = '';
      notes.forEach((n) => {
        n.style.top = '';
        n.style.left = '';
        n.style.width = '';
      });
    }
  }
  const queueLayout = () => {
    if (layoutQueued) return;
    layoutQueued = true;
    requestAnimationFrame(layoutNotes);
  };
  function placeNotes() {
    if (!body.querySelector('.ika-note')) return;
    layoutNotes();
    if ('ResizeObserver' in window) new ResizeObserver(queueLayout).observe(body);
    if (wide.addEventListener) wide.addEventListener('change', queueLayout);
    addEventListener('resize', queueLayout);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueLayout);
  }

  // Objects from the story: the products found in the text go first in the rail at the end
  function fillRail(handles) {
    const rail = document.querySelector('[data-ikn-articleshop]');
    const track = rail && rail.querySelector('[data-ikn-articleshop-track]');
    if (!track || !handles.length) return;
    const handleOf = (a) => (a.getAttribute('href') || '').split('?')[0].split('/').pop();
    // with links in the text ik-next.js fills the rail first: wait for it (at most 5 s), then add the rest
    const ready = () =>
      new Promise((resolve) => {
        if (!linked.length) return resolve();
        const t0 = Date.now();
        const check = () => {
          const have = [...track.querySelectorAll('a.ikh-card')].map(handleOf);
          if (linked.some((l) => have.includes(l.h)) || Date.now() - t0 > 5000) return resolve();
          setTimeout(check, 150);
        };
        check();
      });
    ready().then(() => {
    const have = new Set([...track.querySelectorAll('a.ikh-card')].map(handleOf));
    Promise.all(handles.filter((h) => !have.has(h)).map(get)).then((products) => {
      // ik-next.js fills the same rail: look again right before adding, so nothing shows twice
      const now = new Set([...track.querySelectorAll('a.ikh-card')].map(handleOf));
      const html = products.filter((p) => p && p.available && !now.has(p.handle)).map((p) => {
        const im = p.featured_image ? img(p.featured_image, 720) : '';
        const alt = p.images && p.images[1] ? img(p.images[1], 720) : '';
        return '<a class="ikh-card" href="' + esc(base + 'products/' + p.handle) + '"><div class="ikh-card__media">' +
          (im ? '<img src="' + esc(im) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
          (alt ? '<img class="ikh-card__alt" src="' + esc(alt) + '" alt="" loading="lazy">' : '') +
          '</div><div class="ikh-card__meta"><span class="ikh-card__vendor">' + esc(p.vendor) + '</span>' +
          '<span class="ikh-card__title">' + esc(p.title) + '</span>' +
          '<span class="ikh-price"><span>' + (p.price_varies ? esc(str('from', 'from')) + ' ' : '') + money.format(p.price_min / 100) + '</span></span></div></a>';
      }).join('');
      if (!html) return;
      // products chosen for the article (content.products) stay first
      const after = linked.length || rail.hasAttribute('data-ikn-articleshop-picked');
      track.insertAdjacentHTML(after ? 'beforeend' : 'afterbegin', html);
      if (!after) track.scrollLeft = 0;
      if (rail.hidden) {
        const t = rail.querySelector('[data-ikn-articleshop-title]');
        if (t) t.textContent = t.getAttribute('data-ikn-title-links') || t.textContent;
        rail.hidden = false;
      }
      window.dispatchEvent(new Event('resize'));
    });
    });
  }
})();

/* Videos and posts from YouTube, Instagram and X (ik-article.liquid moves their src to data-ika-src).
   They load as soon as the visitor has agreed to cookies (Shopify Customer Privacy, set by the cookie banner),
   otherwise a quiet placeholder stands in their place and one click loads that provider. */
(() => {
  const body = document.querySelector('[data-ika-body]');
  if (!body) return;
  const waiting = [...body.querySelectorAll('[data-ika-src]')];
  if (!waiting.length) return;
  const str = (k, p) => ((document.querySelector('[data-ika-str-' + k + ']') || {}).textContent || '').trim().replace('%p', p);
  const providerOf = (url) => (/youtube/.test(url) ? 'YouTube' : /instagram/.test(url) ? 'Instagram' : 'X');
  const jobs = [];
  const done = new Set();
  const load = (p) => {
    if (done.has(p)) return;
    done.add(p);
    jobs.filter((j) => j.p === p).forEach((j) => j.run());
  };
  const placeholder = (p, kind, ratio) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'ika-embed ika-embed--' + kind;
    if (ratio) b.style.aspectRatio = ratio;
    b.innerHTML = '<span class="ika-embed__label"></span><span class="ika-embed__note"></span>';
    b.firstChild.textContent = str('embed-' + kind, p);
    b.lastChild.textContent = str('embed-note', p);
    b.addEventListener('click', () => load(p));
    return b;
  };
  waiting.filter((el) => el.tagName === 'IFRAME').forEach((fr) => {
    const p = providerOf(fr.dataset.ikaSrc);
    const w = +fr.getAttribute('width') || 16;
    const h = +fr.getAttribute('height') || 9;
    const ph = placeholder(p, 'video', w + ' / ' + h);
    fr.style.display = 'none';
    fr.before(ph);
    jobs.push({ p, run: () => { fr.src = fr.dataset.ikaSrc; fr.style.display = ''; ph.remove(); } });
  });
  [['Instagram', 'blockquote.instagram-media'], ['X', 'blockquote.twitter-tweet']].forEach(([p, sel]) => {
    const script = waiting.find((el) => el.tagName === 'SCRIPT' && providerOf(el.dataset.ikaSrc) === p);
    body.querySelectorAll(sel).forEach((q) => {
      const ph = placeholder(p, 'post');
      q.style.display = 'none';
      q.before(ph);
      jobs.push({ p, run: () => { q.style.display = ''; ph.remove(); } });
    });
    if (script) jobs.push({ p, run: () => { const s = document.createElement('script'); s.async = true; s.src = script.dataset.ikaSrc; document.body.appendChild(s); } });
  });
  /* YouTube counts as "preferences" (functional cookies), Instagram and X as marketing */
  const allows = (c, p) => (p === 'YouTube' ? c.preferences : c.marketing);
  const apply = (c) => ['YouTube', 'Instagram', 'X'].forEach((p) => { if (allows(c, p)) load(p); });
  document.addEventListener('visitorConsentCollected', (e) => {
    const d = e.detail || {};
    apply({ preferences: d.preferencesAllowed, marketing: d.marketingAllowed });
  });
  const check = () => {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) return;
    apply({ preferences: cp.preferencesProcessingAllowed(), marketing: cp.marketingAllowed() });
  };
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (!err) check(); });
  } else check();
})();
